
// @ts-check

import React from "react";

import NamedBuildingScreen from './NamedBuildingScreen';

import '../styles/NamedBuildingScreenLayout.css';


/**
 * @typedef {import('./coreTypes').CampaignSplashInfo} CampaignSplashInfo
 * @typedef {import('./coreTypes').JSX} JSX
 */


/**
 * @param {{ namedBuildings: CampaignSplashInfo[], currentIndex: number, totalPages: number }} props 
 * @returns {JSX}
 */
function NamedBuildingScreenLayout(props) {

    const currentIndex = props.currentIndex;
    const totalPages = props.totalPages;

    const topIndex = 2 * currentIndex;
    const bottomIndex = ((2 * currentIndex + 1) > ((totalPages - 1) * 2)) ? null : (2 * currentIndex + 1);

    const top = props.namedBuildings[topIndex];
    const bottom = (bottomIndex === null) ? null : props.namedBuildings[bottomIndex];

    return (
        <div className="top-container">
            <NamedBuildingScreen top={top} bottom={bottom} />
            <p className="named-building-page-of-page">Page {props.currentIndex+1} of {props.totalPages}</p>
        </div>
        );
}


export default NamedBuildingScreenLayout;